import {CryptoProCert} from '../../types/plugins/cadesPlugin';
import {loadCadesPlugin} from '../../utils/cadesPlugin';

export const useCryptoPro = () => {
    const getCertificatesInfo = async () => {
        try {
            await loadCadesPlugin();
            if (!cadesplugin) return;

            return await cadesplugin.async_spawn(function*() {
                const store = yield cadesplugin.CreateObjectAsync('CAdESCOM.Store');
                yield store.Open(
                    cadesplugin.CAPICOM_CURRENT_USER_STORE,
                    cadesplugin.CAPICOM_MY_STORE,
                    cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
                );

                const certificates = yield store.Certificates;
                const count = yield certificates.Count;

                const certsInfo = [];

                for (let i = 1; i <= count; i++) {
                    const cert = yield certificates.Item(i);

                    const subject_name = yield cert.SubjectName;
                    const issuer_name = yield cert.IssuerName;
                    const serial_number = yield cert.SerialNumber;
                    const thumbprint = yield cert.Thumbprint;
                    const valid_from_date = yield cert.ValidFromDate;
                    const valid_to_date = yield cert.ValidToDate;

                    certsInfo.push({
                        subject_name,
                        issuer_name,
                        serial_number,
                        thumbprint,
                        valid_from_date,
                        valid_to_date,
                    });
                }

                yield store.Close();

                console.log('Сертификаты:', certsInfo);
                return certsInfo;
            });
        } catch (error) {
            console.error('Ошибка получения сертификатов:', error);
        }
    };

    const authorizeWithCertificate = async (thumbprint: string) => {
        try {
            // 1. Получаем nonce от сервера
            // const nonceResponse = await fetch("/api/auth/nonce");
            // const { nonce } = await nonceResponse.json();
            const nonce = '123';

            await loadCadesPlugin();
            if (!cadesplugin) return;

            await cadesplugin.async_spawn(function*() {
                // 2. Открываем хранилище
                const store = yield cadesplugin.CreateObjectAsync('CAdESCOM.Store');
                yield store.Open(
                    cadesplugin.CAPICOM_CURRENT_USER_STORE,
                    cadesplugin.CAPICOM_MY_STORE,
                    cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
                );

                const certificates = yield store.Certificates;
                const count = yield certificates.Count;

                if (count === 0) throw new Error('Нет доступных сертификатов');

                const selectedCert = yield certificates.Find(
                    cadesplugin.CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
                    thumbprint,
                );
                const cert = yield selectedCert.Item(1);

                const subjectName = yield cert.SubjectName;
                const issuerName = yield cert.IssuerName;
                const serialNumber = yield cert.SerialNumber;
                const validFrom = yield cert.ValidFromDate;
                const validTo = yield cert.ValidToDate;

                console.log({
                    subjectName,
                    issuerName,
                    serialNumber,
                    validFrom,
                    validTo,
                    thumbprint,
                });

                yield store.Close();

                // 4. Подписываем nonce
                const signer = yield cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner');
                yield signer.propset_Certificate(cert);
                const signedData = yield cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData');
                yield signedData.propset_ContentEncoding(cadesplugin?.CADESCOM_STRING_TO_UCS2LE);
                yield signedData.propset_Content(nonce);
                const signature = yield signedData.SignCades(
                    signer,
                    cadesplugin.CADESCOM_CADES_BES,
                    true,
                );

                // 5. Получаем сертификат в BASE64
                const base64Cert = yield cert.Export(cadesplugin.CADESCOM_ENCODE_BASE64);

                console.log({
                    certificate: base64Cert,
                    signature,
                    nonce,
                });

                // // 6. Отправляем на бэкенд
                // const response = await fetch('/api/auth/cert-login', {
                //     method: 'POST',
                //     headers: {'Content-Type': 'application/json'},
                //     body: JSON.stringify({
                //         certificate: base64Cert,
                //         signature,
                //         nonce,
                //     }),
                // });
                //
                // if (!response.ok) throw new Error('Ошибка авторизации');
                // const result = await response.json();
                // console.log('Успешная авторизация:', result);
            });
        } catch (error) {
            console.error('Ошибка авторизации через сертификат:', error);
        }
    };

    const parseCertificate = (cert: CryptoProCert): CryptoProCert => {
        const sanitizeKeys = (string: string) =>
            string
                .split(',')
                .map((part) => part.trim())
                .map(
                    (part) =>
                        part
                            .replace(
                                /^((?![А-Яа-яЁё])[A-Za-z0-9_\-"]+)= */g, // убрать латинские ключи и "="
                                '',
                            )
                            .replace(/^([А-Яа-яЁё ."\-0-9]+)= */, '$1: '), // оставить кириллические ключи, заменить '=' на ': ' (или просто ' ')
                )
                .join(', ');

        return (Object.keys(cert) as (keyof CryptoProCert)[]).reduce((acc, key) => {
            acc[key] = sanitizeKeys(cert[key]);
            return acc;
        }, {} as CryptoProCert);
    };

    return {getCertificatesInfo, authorizeWithCertificate, parseCertificate};
};
